import { PartialType } from '../../../../utils';
import { CreatePartSupplierDto } from '../create/create-part-supplier.dto';
export class UpdatePartSupplierDto extends PartialType(CreatePartSupplierDto) {
}
